import { useContext, useEffect, useState } from 'react';
import { AppContext } from 'App.context';

// not used needed by react for the jsx
export default function useDefaultLegalDocumentsHook() {
  const {
    appActions: { translate, getSelectedHotel },
  } = useContext(AppContext);

  const [state, setState] = useState({
  });
  useEffect(() => {
  }, []);
  
  const actions = {

  };



  return { state, actions };
}
